import { render, staticRenderFns } from "./ReportingRestrictionsGroup.vue?vue&type=template&id=01cca325"
import script from "./ReportingRestrictionsGroup.vue?vue&type=script&lang=js"
export * from "./ReportingRestrictionsGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports